<template>
  <a-modal
    title="附件列表"
    :visible="visible"
    @cancel="$emit('close')"
    :footer="null"
    width="600px"
  >
    <a-table
      :data-source="attachmentList"
      :columns="columns"
      rowKey="id"
      bordered
      :pagination="false"
    >
      <template slot="action" slot-scope="text, record">
        <a-space>
          <a :href="record.completePath || record.url" target="_blank">预览</a>
        </a-space>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
export default {
  name: 'LeaveAttachmentList',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    attachmentList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      columns: [
        {
          title: '附件名称',
          dataIndex: 'name',
          width: '60%'
        },
        {
          title: '后缀',
          dataIndex: 'ext',
          width: '10%'
        },
        {
          title: '操作',
          width: '30%',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    };
  }
};
</script>
